import notifications from 'src/screens/notifications';
export default notifications;
